import React from 'react';
import { useDispatch } from 'react-redux';
import { clearUser } from '../feature/user.Slice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons'; 


/**
 * @module Components/LogOut
 * @description Logout est un composant qui permet à l'utilisateur de se déconnecter.
 * - Il utilise le hook useDispatch de 'react-redux' pour dispatcher l'action clearUser.
 * - Lorsque l'utilisateur clique sur le bouton 'Se déconnecter', l'action clearUser est dispatchée,
 * ce qui efface les informations de l'utilisateur du store Redux.
 *
 */

const Logout = () => {
    const dispatch = useDispatch();

    const handleLogout = () => {
        // Dispatch l'action clearUser
        dispatch(clearUser());
    };

    return (
        <button 
            className="px-3 lg:px-4 py-2 rounded-lg font-medium transition-all duration-200 text-red-600 hover:bg-red-50 hover:text-red-700 border border-red-200 hover:border-red-300 w-full md:w-auto"
            onClick={handleLogout}
        >
            <FontAwesomeIcon icon={faSignOutAlt} className="mr-2" />
            Se déconnecter
        </button>
    );
};

export default Logout;